import { http, ep } from '../../client/http';

export const socialRepo = {
  get: async () => {
    const res = await http.get(ep('social/list'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
